
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { MAX_FILE_SIZE, ACCEPTED_FILE_TYPES } from './ContactFormSchema';

interface FileUploaderProps {
  selectedFile: File | null;
  setSelectedFile: (file: File | null) => void;
  fileUploading?: boolean;
  isSubmitting?: boolean;
}

export const FileUploader = ({ selectedFile, setSelectedFile, fileUploading = false, isSubmitting = false }: FileUploaderProps) => {
  const { toast } = useToast();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    
    if (!file) {
      return;
    }
    
    // Check file size
    if (file.size > MAX_FILE_SIZE) {
      toast({
        title: "File too large",
        description: "Please upload a file smaller than 5MB",
        variant: "destructive",
      });
      return;
    }
    
    // Check file type
    if (!ACCEPTED_FILE_TYPES.includes(file.type)) {
      toast({
        title: "Invalid file type",
        description: "Please upload a PDF, Word document, or image file",
        variant: "destructive",
      });
      return;
    }
    
    setSelectedFile(file);
  };

  return (
    <div className="text-left">
      <Label htmlFor="file" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
        Attachment (PDF, resume, job description, etc.)
      </Label>
      <div className="mt-2">
        <Input
          id="file"
          type="file"
          onChange={handleFileChange}
          accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
          disabled={isSubmitting || fileUploading}
          className="file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-sage-50 file:text-sage-700 hover:file:bg-sage-100"
        />
        {selectedFile && (
          <p className="text-xs text-sage-600 mt-1">
            Selected: {selectedFile.name}
          </p>
        )}
      </div>
    </div>
  );
};
